import React from 'react';
import { connect } from 'react-redux';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {
  date_range, dsn, oem_id, oem_model, sw_version,
} from '../../filters/filterPanel/FilterPanel';
import ReportPage from '../ReportPage';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, datapointsAverageTransmissionsPerDevice,
  datapointsTotalTransmissionsOverTime, devicesOnlineToday, listOfOemModels, listOfOems,
  listOfSwVersions, totalDatapoints, contractTotalDatapointsTransactions, contractDatapointsTransactionsOverTime, as3D
} from '../../../services/reportsservice';
import './DatapointTransmissionTrendsPage.css';
import {logPageViewEvent} from "../../../services/analyticsservice";
import {t} from "i18next";
import {getErrorReportNames, getReportData} from "../../../helpers/utils";


class DatapointTransmissionTrendsPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.DatapointTransmissionTrendsPage.title, logged_in_oem_id);
  }
  reports() {
    const defaultArguments = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
        && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
        && this.props.presistFilters.oem_id === '39a9391a');

    return {

      filters: [
        listOfOemModels(defaultArguments),
        listOfSwVersions(defaultArguments),
        listOfOems(defaultArguments),
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
        activatedDevices(defaultArguments),
        devicesOnlineToday(defaultArguments),
        contractTotalDatapointsTransactions(defaultArguments),
        contractDatapointsTransactionsOverTime(defaultArguments),
        ]
        : [
        activatedDevices(defaultArguments),
        devicesOnlineToday(defaultArguments),
        datapointsAverageTransmissionsPerDevice(defaultArguments),
        datapointsTotalTransmissionsOverTime(defaultArguments),
        totalDatapoints(defaultArguments),
      ],
    };
  }

  reportsDescription = () => [
    datapointsTotalTransmissionsOverTime(),
    datapointsAverageTransmissionsPerDevice(),
  ];

  render() {
    const { fetchData, session, isMeteringApi, errors } = this.props;
    if(errors.length > 0) getErrorReportNames(errors);
    let activated_devices = getReportData(this.report(activatedDevices),'Activated_Devices');
    let contract_datapoints_transactions_over_time = getReportData(this.report(contractDatapointsTransactionsOverTime),
      'Contract_Metering_Datapoint_Transactions_Over_Time');
    const datapointsAvgTransmissionsPerDevice = activated_devices === t('unableToFetchData')
    || contract_datapoints_transactions_over_time === t('unableToFetchData')
      ? t('unableToFetchData') : (activated_devices
      && contract_datapoints_transactions_over_time
      && as3D('x', 'y', 'z')([
        ...contract_datapoints_transactions_over_time[0].values.map(entry => ({
          z: 'batch_datapoint',
          ...entry, y: Math.floor(entry.y / activated_devices),
        })),
        ...contract_datapoints_transactions_over_time[1].values.map(entry => ({
          z: 'single_datapoint',
          ...entry, y: Math.floor(entry.y / activated_devices),
      })),
    ]));

    return (
      <div className="DatapointTransmissionTrendsPage page">
        <TitleBar title="datapointTransmissionTrends">
          <TimeAggregation value={this.props.presistFilters.aggregate_by} />
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={this.props.presistFilters}
            filters={[
              date_range,
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(listOfOems)),
              oem_model(this.report(listOfOemModels)),
              sw_version(this.report(listOfSwVersions)),
              dsn(),
            ]}
          />

          <div>
            { ! isMeteringApi && <BarChart title="dpTransmissionTrends.total"
              width={this.widthForColumns(1)}
              height={200}
              data={getReportData(this.report(datapointsTotalTransmissionsOverTime), 'Total_Transmissions_Over_Time')}
              description={this.reportDescription(datapointsTotalTransmissionsOverTime)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="transmissions"
              skipDetailsTranslation
              />
            }
            {  isMeteringApi && <BarChart title="dpTransmissionTrends.total"
               width={this.widthForColumns(1)}
               height={200}
               data={contract_datapoints_transactions_over_time}
               xLabel={this.props.presistFilters.aggregate_by}
               yLabel="transmissions"
               skipDetailsTranslation
               grouped
            />
            }

          </div>
          <div>
            { ! isMeteringApi && <BarChart title="dpTransmissionTrends.average"
              width={this.widthForColumns(1)}
              height={200}
              data={getReportData(this.report(datapointsAverageTransmissionsPerDevice), 'Average_Transmissions_Per_Device_Over_Time')}
              description={this.reportDescription(datapointsAverageTransmissionsPerDevice)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="transmissions"
              skipDetailsTranslation
            />
            }
            {  isMeteringApi && <BarChart title="dpTransmissionTrends.average"
             width={this.widthForColumns(1)}
             height={200}
             data={datapointsAvgTransmissionsPerDevice}
             description={this.reportDescription(datapointsAverageTransmissionsPerDevice)}
             xLabel={this.props.presistFilters.aggregate_by}
             yLabel="transmissions"
             skipDetailsTranslation
             grouped
            />
            }

          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(DatapointTransmissionTrendsPage);
